import { message } from "ant-design-vue";
import store from "@/src/store/index.js";
import eventBus from "@/src/utils/eventBus.js";
import AnalyticService from "@/src/api/AnalyticService.js";
import { dashboardEvents } from "@/src/constants/analyticConstants.js";

export function useAnalyticsDashboard() {
  const createDashboard = async (payload, router) => {
    try {
      await store.dispatch("analytics/resetState");

      const response = await AnalyticService.V3.createDashboard(payload);
      if (response?.success && response?.data?.id) {
        message.success(`Dashboard ${payload.name} created successfully!`);

        eventBus.emit("dashboard-manipulated", {
          event: dashboardEvents.CREATED,
          item: response.data,
          spaceId: payload.space_id || null,
        });

        await store.dispatch("analytics/setSelectedDashboard", {
          ...response.data,
          type: response.data?.type || payload.type,
        });

        await router.push({
          name: "analytics-dashboard",
          params: { dashboard_id: response.data.id },
        });

        return response.data;
      } else {
        message.error("Failed to create dashboard");
        return null;
      }
    } catch (error) {
      console.error("An error occurred while creating dashboard: ", error);
      message.error("An error occurred while creating a dashboard!");
      return null;
    }
  };

  const applyTemplateAndCreate = async (templateId, payload, router) => {
    try {
      const response = await AnalyticService.V3.applyTemplate(
        templateId,
        payload,
      );
      if (response?.success && response?.data?.dashboard?.id) {
        const dashboard = response.data.dashboard;

        message.success(`Dashboard created from template successfully!`);

        eventBus.emit("dashboard-manipulated", {
          event: dashboardEvents.CREATED,
          item: dashboard,
          spaceId: payload.space_id || null,
        });

        await store.dispatch("analytics/setSelectedDashboard", dashboard);

        await router.push({
          name: "analytics-dashboard",
          params: { dashboard_id: dashboard.id },
        });

        return dashboard;
      } else {
        message.error("Failed to apply template");
        return null;
      }
    } catch (error) {
      console.error("An error occurred while applying template: ", error);
      message.error("Failed to apply template!");
      return null;
    }
  };

  return {
    createDashboard,
    applyTemplateAndCreate,
  };
}
